import React, { Component } from 'react'
import { Row, Col } from 'react-bootstrap'

export default class index extends Component {
    render() {
        return (
            <div className="how-does-it-works counter-box">
                <Row>
                    <Col md={3} className="pl-0">
                        <div className="text-center">
                            <div className="slick-content-name desktop">CITIES</div>
                            <div className="slick-content-name desktop">SERVICED</div>
                            <div className="slick-content-name mobile">CITIES SERVICED</div>
                            <div className="count-text">19+</div>
                        </div>
                    </Col>
                    <Col>
                        <div className="text-center">
                            <div className="slick-content-name desktop">DEVICES</div>
                            <div className="slick-content-name desktop">REPAIRED</div>
                            <div className="slick-content-name mobile">DEVICE REPAIRS</div>
                            <div className="count-text">3,00,000+</div>
                        </div>
                    </Col>
                    <Col md={3}>
                        <div className="text-center">
                            <div className="slick-content-name desktop">GOOGLE</div>
                            <div className="slick-content-name desktop">RATINGS</div>
                            <div className="slick-content-name mobile">GOOGLE RATINGS</div>
                            <div className="count-text">4.7/5</div>
                        </div>
                    </Col>
                </Row>
            </div>
        )
    }
}
